"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoverageIntegration = void 0;
let CoverageIntegration = exports.CoverageIntegration = void 0;
(function (_CoverageIntegration) {
  let Status = /*#__PURE__*/function (Status) {
    Status["ACTIVE"] = "active";
    Status["PAUSED"] = "paused";
    Status["TRIAL"] = "trial";
    Status["DELETED"] = "deleted";
    return Status;
  }({});
  _CoverageIntegration.Status = Status;
})(CoverageIntegration || (exports.CoverageIntegration = CoverageIntegration = {}));